// // Sidebar.js (React + Bootstrap version)
// import React from "react";
// import { Link } from "react-router-dom"; // Use react-router-dom for routing
// import { Gauge, LayoutList, Layers2, User } from "lucide-react";

// export default function Sidebar() {
//   const link = [
//     {
//       name: "Dashboard",
//       link: "/admin",
//       icon: <Gauge />,
//     },
//     {
//       name: "Authors",
//       link: "/admin/authors",
//       icon: <User />,
//     },
//     {
//       name: "Posts",
//       link: "/admin/posts",
//       icon: <LayoutList />,
//     },
//     {
//       name: "Categories",
//       link: "/admin/categories",
//       icon: <Layers2 />,
//     },
//     {
//       name: "Archives",
//       link: "/admin/archives",
//       icon: <LayoutList />, // You can use a different icon if preferred
//     },
//   ];

//   return (
//     <section className=" col-12 col-md-3 col-lg-2 border-end p-2">
//       <ul className="list-unstyled">
//         {link.map((item) => {
//           return (
//             <li key={item.name} className="mb-3">
//               <Link
//                 to={item.link}
//                 className="d-flex align-items-center bg-light rounded-pill px-4 py-2 text-decoration-none"
//               >
//                 {item.icon}
//                 <span className="ms-2">{item.name}</span>
//               </Link>
//             </li>
//           );
//         })}
//       </ul>
//     </section>
//   );
// }

import React from "react";
import { Link } from "react-router-dom";
import { Gauge, LayoutList, Layers2, User, Newspaper } from "lucide-react";

export default function Sidebar() {
  const link = [
    {
      name: "Dashboard",
      link: "/admin",
      icon: <Gauge />,
    },
    {
      name: "Authors",
      link: "/admin/authors",
      icon: <User />,
    },
    {
      name: "Posts",
      link: "/admin/posts",
      icon: <LayoutList />,
    },
    {
      name: "Categories",
      link: "/admin/categories",
      icon: <Layers2 />,
    },
    {
      name: "Archives",
      link: "/admin/archives",
      icon: <LayoutList />,
    },
    {
      name: "Newsletters",
      link: "/admin/newsletters",
      icon: <Newspaper />,
    },
  ];

  return (
    <section className="col-12 col-md-3 col-lg-2 border-end p-2">
      <ul className="list-unstyled">
        {link.map((item) => {
          return (
            <li key={item.name} className="mb-3">
              <Link
                to={item.link}
                className="d-flex align-items-center bg-light rounded-pill px-4 py-2 text-decoration-none"
              >
                {item.icon}
                <span className="ms-2">{item.name}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
